import PageWithHero from "../components/legal/PageWithHero";
import FaqAccordion from "../components/legal/FaqAccordion";
import useSEO from "../hooks/useSEO";
import { generateFAQSchema } from "../utils/schemaGenerators";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { getLegalPage } from "../services/legalServices";

export default function FAQPage() {
  const { i18n, t } = useTranslation();
  const [page, setPage] = useState(null);
  const faqItems = useMemo(
    () =>
      (page?.faqs || [])
        .filter((f) => f.question && f.answer)
        .map((f) => ({ q: f.question, a: f.answer })),
    [page]
  );

  useEffect(() => {
    let cancel = false;
    getLegalPage("faq", i18n.language)
      .then((res) => {
        if (!cancel) setPage(res);
      })
      .catch(() => {
        if (!cancel) setPage(null);
      });
    return () => {
      cancel = true;
    };
  }, [i18n.language]);

  const seo = useSEO({
    schema: generateFAQSchema(faqItems.map((f) => ({ question: f.q, answer: f.a }))),
  });

  return (
    <>
      {seo}
      <PageWithHero
        title={page?.title || t("legalPages.faq.title")}
        subtitle={page?.subtitle || t("legalPages.faq.subtitle")}
      >
        {faqItems.length ? (
          <FaqAccordion items={faqItems} />
        ) : (
          <p>{t("legalPages.dynamicFallback")}</p>
        )}
      </PageWithHero>
    </>
  );
}
